export const SET_EMAIL_TO_VERIFY = 'SET_EMAIL_TO_VERIFY';
export const SET_IS_REGISTER_FLOW = 'SET_IS_REGISTER_FLOW';
